import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { PermissionService } from "../services/permission.service";
import { UserService } from "../services/user.service";
import { Claims } from "../constants";

@Injectable({ providedIn: "root" })
export class SettingsGuard {
  protected _router = inject(Router);
  protected _userService = inject(UserService);
  protected _permission = inject(PermissionService);

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!this._userService.CurrentUser) {
      return false;
    }
    if (!this._userService.CurrentUser.internalAccess) {
      this._router.navigate(["/infoportal"]);
      return false;
    }
    const permProp = route.data["permProp"];
    if (permProp) {
      return this._permission[permProp];
    }
    return (
      this._userService.CurrentUser && this._permission.UserCan_AccessSettings
    );
  }
}

@Injectable({ providedIn: "root" })
export class SettingsOnlyAdminGuard extends SettingsGuard {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (!super.canActivate(route, state)) {
      return false;
    }
    return this._userService.HasClaim(Claims.Administration_IstAdmin);
  }
}
